<div class="progress-dialog" [class.all-complete]="allCompleted">
  <div class="bg-glow bg-glow-1"></div>
  <div class="bg-glow bg-glow-2"></div>

  <header class="dialog-header">
    <div class="title-block">
      <div class="icon-box" [class.icon-box--success]="allCompleted">
        <mat-icon>{{ allCompleted ? 'celebration' : 'route' }}</mat-icon>
      </div>
      <div>
        <h2>Onboarding Progress</h2>
        <p *ngIf="vesselName">{{ vesselName }}</p>
        <p *ngIf="!vesselName">Track completion across onboarding modules</p>
      </div>
    </div>
    <button type="button" class="icon-close" (click)="dismiss()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="dialog-body">
    <div class="success-banner" *ngIf="allCompleted">
      <div class="success-animation">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h3>All onboarding modules have been completed successfully.</h3>
      <p>Your vessel is fully onboarded across Sailing, Port, Emission, and Cargo Heating.</p>
    </div>

    <ol class="progress-timeline">
      <li
        class="timeline-item"
        *ngFor="let module of modules; let last = last"
        [class.completed]="module.status === 'completed'"
        [class.pending]="module.status === 'pending'"
      >
        <div class="timeline-marker" aria-hidden="true">
          <mat-icon *ngIf="module.status === 'completed'">check_circle</mat-icon>
          <mat-icon *ngIf="module.status === 'pending'">schedule</mat-icon>
        </div>
        <div class="timeline-content" [class.timeline-content--last]="last">
          <div class="timeline-heading">
            <span class="status-icon" aria-hidden="true">
              {{ module.status === 'completed' ? '✅' : '⏳' }}
            </span>
            <div>
              <h4>{{ module.label }}</h4>
              <p>{{ module.status === 'completed' ? 'Completed' : 'Pending' }}</p>
            </div>
          </div>

          <button
            *ngIf="module.status === 'pending'"
            type="button"
            class="btn-process"
            (click)="processModule(module.key)"
          >
            {{ module.processLabel }}
          </button>
        </div>
      </li>
    </ol>
  </section>

  <footer class="dialog-footer">
    <button type="button" class="btn-secondary" (click)="dismiss()">
      {{ allCompleted ? 'Close' : 'Continue Later' }}
    </button>
    <button *ngIf="allCompleted" type="button" class="btn-primary" (click)="finish()">
      <mat-icon>done_all</mat-icon>
      Finish Onboarding
    </button>
  </footer>
</div>
